import React from "react";

import { graphql } from "gatsby";

import mapMegaMenuResultItems from "./megaMenu/mapMegaMenuResultItems";
import MegaMenuResultsCampaign from "./megaMenu/megaMenuResultsCampaign";
import MegaMenuResultsEvent from "./megaMenu/megaMenuResultsEvent";
import MegaMenuResultsNews from "./megaMenu/megaMenuResultsNews";

interface KontentItemMegaMenuDataProps {
  data: Queries.kontent_item_megamenu_data;
}

const KontentItemMegaMenuData: React.FC<KontentItemMegaMenuDataProps> = ({ data }) => {
  if (!data || !data.elements) {
    return null;
  }

  const elements = data.elements!;

  if ((elements.selected_items?.value?.length ?? 0) > 0) {
    return elements.selected_items?.value?.map(
      (item) => mapMegaMenuResultItems(item as Queries.kontent_item),
    );
  }

  if ((elements.campaign?.value?.length ?? 0) > 0) {
    return <MegaMenuResultsCampaign />;
  }

  if ((elements.event_category?.value?.length ?? 0) > 0) {
    return (
      <MegaMenuResultsEvent
        item={{
          categories: elements.event_category?.value?.map((event) => event?.codename || ""),
        }}
      />
    );
  }

  if ((elements.news_category?.value?.length ?? 0) > 0) {
    return (
      <MegaMenuResultsNews
        item={{
          categories: elements.news_category?.value?.map((news) => news?.codename || ""),
        }}
      />
    );
  }

  return null;
};

export const query = graphql`
  fragment KontentItemMegaMenuData on kontent_item_megamenu_data {
    id
    elements {
      campaign {
        value {
          codename
        }
      }
      event_category {
        value {
          codename
        }
      }
      news_category {
        value {
          codename
        }
      }
      page_description {
        value
      }
      selected_items {
        value {
          internal {
            type
          }
          ...MegaMenuResultProgram
          ...MegaMenuResultLearn
          ...MegaMenuResultDonorArea
          ...MegaMenuResultTargetGroupPage
        }
      }
    }
  }
`;

export default KontentItemMegaMenuData;
